<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div>
    <BLM-h3-title>
      <template slot="title">批量收款详情</template>
    </BLM-h3-title>
    <BLM-h4-title title="批量收款信息" />
    <column-box :source="source" :list="list" label-width="160px"> </column-box>
    <div class="splitline mt16 mb16"></div>
    <BLM-h4-title title="收款详情" />
    <!-- 开始 ---列表 -->
    <BLM-common-table ref="table"
      :data="receivableList"
      :columns="headData"
      :pagination="pagination"
    />
    <!-- 结束 ---列表 -->
  </div>
</template>

<script>
import { getBatchReceivableOnlineDetail, getbatchCollectionRecordDetails } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  name: 'cpInfoDetail',
  data() {
    return {
      source: {},
      receivableList: [],
      pageNum: 1,
      pageSize: 1000,
      total: 0,
      headData: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '收款单号',
          },
        },
        {
          name: 'receivableId',
          columnProps: {
            prop: 'receivableId',
            label: '相关应收单号',
          },
        },
        {
          name: 'customerId',
          columnProps: {
            prop: 'customerId',
            label: '司机编号',
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '司机名称',
          },
        },
        {
          name: 'idCardNo',
          columnProps: {
            prop: 'idCardNo',
            label: '身份证号',
          },
        },
        {
          name: 'mobile',
          columnProps: {
            prop: 'mobile',
            label: '手机号',
            width: 110,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            prop: 'receivableDate',
            label: '应收日期',
          },
        },
        {
          name: 'actualDate',
          columnProps: {
            prop: 'actualDate',
            label: '实收日期',
          },
        },
        {
          name: 'actualAmount',
          columnProps: {
            prop: 'actualAmount',
            label: '收款金额（元）',
          },
          getText: ({ row }) => this.numberWithCommas(row.actualAmount),
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '收款单状态',
          },
          getText: ({ row }) => selectOption.collectionStateList[row.state],
        },
      ],
      list: [
        {
          key: 'id',
          name: '批量收款ID',
        },
        {
          key: 'state',
          name: '批量收款状态',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'payMethodName',
          name: '支付方式',
        },
        {
          key: 'amount',
          name: '收款金额',
        },
        {
          key: 'fenceStartDate',
          name: '应收开始日期',
        },
        {
          key: 'fenceEndDate',
          name: '应收结束日期',
        },
        {
          key: 'fundTypeName',
          name: '支付内容',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    pagination() {
      return {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        total: this.total,
      }
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  methods: {
    async getDetail(id) {
      const { code, data } = await getbatchCollectionRecordDetails({ id })
      if (code === 1) {
        this.source = {
          ...data,
          fundTypeName: this.formatEnumeration(this.freeTypeList)[data.fundType],
          payMethodName: selectOption.payMethods[data.payMethod],
          state: selectOption.collectionStateList[data.state],
          amount: `${this.numberWithCommas(data.amount)} 元 `,
        }
      }
    },
    getBatchReceivableOrderList(id) {
      getBatchReceivableOnlineDetail({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.receivableList = data || []
        }
      })
    },
  },
  mounted() {
    const { id } = this.$route.query
    if (id) {
      this.getDetail(id)
      this.getBatchReceivableOrderList(id)
    } else {
      this.$message.error('缺少参数')
      this.$router.back()
    }
  },
}
</script>

<style lang="scss" scoped>
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .blm-h4-container-left {
  font-size: 16px;
}

.company_photos {
  ::v-deep .el-form-item__label {
    min-width: 162px;
  }

  .images-list {
    font-size: 0;
    width: 500px;
    height: 200px;
    flex-wrap: wrap;

    img {
      width: 80px;
      height: 80px;
      margin-left: 12px;

      &:nth-child(1),
      &:nth-of-type(6) {
        margin-left: 0;
      }

      &:nth-of-type(n + 6) {
        margin-top: 16px;
      }
    }
  }
}
</style>
